import { logErrorToConsole } from '../../constants';

const getPreferredCabins = (searchObj) => {
  try {
    if (!searchObj || !Array.isArray(searchObj.flightSegments))
      throw Error('invalid searchObj passed.');

    const preferredCabins =
      (searchObj &&
        searchObj.flightSegments &&
        searchObj.flightSegments.length > 0 &&
        searchObj.flightSegments.map((segment) => segment.preferredCabin)) ||
      [];

    return preferredCabins;
  } catch (error) {
    logErrorToConsole('[ERROR] occured in getPreferredCabins: ', error);
    return [];
  }
};

export default getPreferredCabins;
